const getObjectEntries = <T extends Record<any, any>, K extends keyof T>(arg: T): [K, T[K]][] => {
  return Object.entries(arg) as [K, T[K]][];
};

export default getObjectEntries;
